<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'
import { usePortalStore } from '@/stores/portal.store'
import { textColor } from '@/lib/utils'

const props = defineProps({
  status: {
    type: Number,
    default: null,
  },
  resendable: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})
defineEmits(['resend'])

const i18n = getI18n()
const portalStore = usePortalStore()

const statusInfo = computed(() =>
  portalStore.getLocalizedPortalAccessStatuses().find(s => s.id === props.status) || null)
</script>

<template>
  <q-chip
    v-if="statusInfo"
    size="sm"
    :style="{ 'background-color': statusInfo.color, color: textColor(statusInfo.color) }"
  >
    {{ statusInfo.label }}
    <template v-if="resendable">
      <q-spinner v-if="loading" size="xs" class="q-ml-xs" />
      <q-icon
        v-else
        name="mdi-email-sync-outline"
        size="xs"
        class="cursor-pointer q-ml-xs"
        @click.stop="$emit('resend')"
      >
        <q-tooltip>{{ i18n.t('common.resendInvite') }}</q-tooltip>
      </q-icon>
    </template>
  </q-chip>
</template>
